import type {StateProvider} from '@uirouter/angularjs';

/*@ngInject*/
export default function homeRoutes($stateProvider: StateProvider) {
    $stateProvider
        .state('home', {
            url: '/',
            templateUrl: '/views/index'
        });
}